import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=82704d4a&"
import script from "./Dashboard.vue?vue&type=script&lang=js&"
export * from "./Dashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/miryamfv/Proyectos/valet/dz0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('82704d4a')) {
      api.createRecord('82704d4a', component.options)
    } else {
      api.reload('82704d4a', component.options)
    }
    module.hot.accept("./Dashboard.vue?vue&type=template&id=82704d4a&", function () {
      api.rerender('82704d4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/pages/Dashboard.vue"
export default component.exports